// バリアント追加POPUPの価格を「¥+3桁区切り」に書き換える
function formatPrice(el) {
  const text = el.textContent.trim();
  const match = text.match(/^JPY\s*([\d]+)$/);
  if (match) {
    const num = parseInt(match[1], 10);
    el.textContent = '¥' + num.toLocaleString('ja-JP');
  }
}

// 現在の価格を変換
const priceEl = document.getElementById('swym-custom-variant-price');
if (priceEl) formatPrice(priceEl);

// バリアント切替時にも対応（MutationObserver）
if (!window._swymPriceObserver) {
  window._swymPriceObserver = new MutationObserver(() => {
    const el = document.getElementById('swym-custom-variant-price');
    if (el) formatPrice(el);
  });
  const container = document.querySelector('.swym-collection-title-detail') || document.body;
  window._swymPriceObserver.observe(container, { childList: true, subtree: true, characterData: true });
}
